import { render, staticRenderFns } from "./responsabilidades-sgsst.vue?vue&type=template&id=a1c6a3aa&scoped=true&"
import script from "./responsabilidades-sgsst.vue?vue&type=script&lang=js&"
export * from "./responsabilidades-sgsst.vue?vue&type=script&lang=js&"
import style0 from "./responsabilidades-sgsst.vue?vue&type=style&index=0&id=a1c6a3aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c6a3aa",
  null
  
)

export default component.exports